import React from 'react'
import propTypes from 'prop-types'
import { Card } from '../layout/Card'

/*
 * Cue Card is a small card that typically contains key/value
 * pairs of information for an entity.
 * Cue Cards behave and can contain any Card element within.
 */
export const CueCard = ({ isNew, warning, children, highlighted, hoverBorder, ...rest }) => {
  return (
    <Card
      highlighted={highlighted}
      darkBorder={hoverBorder}
      cueCard
      isNew={isNew}
      warning={warning}
      className={'justify-between'}
      {...rest} // Pass any other props to the Card component
    >
      {children}
    </Card>
  )
}

export const CueCardTitle = ({ children }) => {
  return (
    <p className='title'>
      {children}
    </p>
  )
}

export const CueCardItem = ({ name, value }) => {
  return (
    <div className='item'>
      <p>{name}</p>
      <p className='item-info'>{value}</p>
    </div>
  )
}

CueCard.defaultProps = {
  hoverBorder: true
}

CueCard.propTypes = {
  isNew: propTypes.bool,
  warning: propTypes.bool,
  children: propTypes.node,
  highlighted: propTypes.bool,
  hoverBorder: propTypes.bool,
}
